import { FrameworkControlCsvHeaders } from 'src/api/types/misc';
import { downloadCsvRows, sanitizeFilename } from 'src/utils/csvExport';
import { formatDate, sanitizeForCSV } from 'src/utils/misc';

type FrameworkControlRow = {
  frameworkControl: {
    id: string;
    control_identifier?: string | null;
    name?: string | null;
    shortname?: string | null;
    strategy?: string | null;
    description?: string | null;
  };
};

type DownloadFrameworkControlsCsv = (params: {
  framework: {
    id: string;
    framework_identifier?: string | null;
    name?: string | null;
    shortname?: string | null;
    author?: string | null;
    version?: string | null;
    publishDate?: string | null;
    description?: string | null;
  };
  controls: FrameworkControlRow[];
}) => void;

export const downloadFrameworkControlsCsv: DownloadFrameworkControlsCsv = ({ framework, controls }) => {
  const controlRows = controls.length ? controls : [null];
  const rows = [
    [
      FrameworkControlCsvHeaders.FrameworkID,
      FrameworkControlCsvHeaders.FrameworkIdentifier,
      FrameworkControlCsvHeaders.FrameworkName,
      FrameworkControlCsvHeaders.FrameworkShortName,
      FrameworkControlCsvHeaders.FrameworkAuthor,
      FrameworkControlCsvHeaders.FrameworkVersion,
      FrameworkControlCsvHeaders.FrameworkPublishDate,
      FrameworkControlCsvHeaders.FrameworkDescription,
      FrameworkControlCsvHeaders.ID,
      FrameworkControlCsvHeaders.FrameworkControlID,
      FrameworkControlCsvHeaders.ControlName,
      FrameworkControlCsvHeaders.ShortName,
      FrameworkControlCsvHeaders.Strategy,
      FrameworkControlCsvHeaders.Description,
    ],
    ...controlRows.map((controlRow) => [
      sanitizeForCSV(framework.id),
      sanitizeForCSV(framework.framework_identifier),
      sanitizeForCSV(framework.name),
      sanitizeForCSV(framework.shortname),
      sanitizeForCSV(framework.author),
      sanitizeForCSV(framework.version),
      formatDate(framework.publishDate),
      sanitizeForCSV(framework.description),
      sanitizeForCSV(controlRow?.frameworkControl.id),
      sanitizeForCSV(controlRow?.frameworkControl.control_identifier),
      sanitizeForCSV(controlRow?.frameworkControl.name),
      sanitizeForCSV(controlRow?.frameworkControl.shortname),
      sanitizeForCSV(controlRow?.frameworkControl.strategy),
      sanitizeForCSV(controlRow?.frameworkControl.description),
    ]),
  ];

  downloadCsvRows({
    rows,
    delimiter: ';',
    filename: `${sanitizeFilename(framework.shortname || framework.name, 'Framework')}_Framework_Controls.csv`,
  });
};
